import {
  ExclamationMarkCircleFilled,
  ExclamationMarkTriangleFilled,
} from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import {
  OpenTofuMigrationQueueEntryNode,
  OpenTofuMigrationWaitingForRunsIssueNode,
} from "shared/Stack/OpenTofuMigration/gql";
import {
  getOpenTofuMigrationFailedIssue,
  getOpenTofuMigrationWaitingForRunsIssue,
} from "shared/Stack/OpenTofuMigration/helpers";
import { pluralizeNext } from "shared/Pluralize";

const getOpenTofuMigrationWaitingForRunsHref = (
  stackId: string,
  issue: OpenTofuMigrationWaitingForRunsIssueNode
) => {
  const [firstRun] = issue.runs;

  if (issue.totalCount === 1 && firstRun) {
    return `/stack/${stackId}/run/${firstRun.id}`;
  }

  return `/stack/${stackId}`;
};

const OpenTofuMigrationQueueTableIssuesCell = ({
  item: entry,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrationQueueEntryNode>) => {
  const failedIssue = getOpenTofuMigrationFailedIssue(entry.issues);
  const waitingForRunsIssue = getOpenTofuMigrationWaitingForRunsIssue(entry.issues);

  return (
    <TableSimpleCell {...cellProps}>
      {failedIssue && (
        <Box gap="medium" align="center" fullWidth>
          <Icon src={ExclamationMarkCircleFilled} color="danger" noShrink />
          <TableCellText>{failedIssue.note || "Unknown error"}</TableCellText>
        </Box>
      )}
      {waitingForRunsIssue && (
        <Box gap="medium" align="center" fullWidth>
          <Icon src={ExclamationMarkTriangleFilled} color="warning" noShrink />
          <TableCellLink
            href={getOpenTofuMigrationWaitingForRunsHref(entry.stack.id, waitingForRunsIssue)}
          >
            {`Waiting for ${pluralizeNext(waitingForRunsIssue.totalCount, "run", undefined, "a")}`}
          </TableCellLink>
        </Box>
      )}
      {!failedIssue && !waitingForRunsIssue && <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default OpenTofuMigrationQueueTableIssuesCell;
